<template>
  <div
    :style="{flex: 1, justifyContent: 'right'}"
    class="with-padding"
  >
    {{ value }}
    <span v-if="suffix">&nbsp;{{ suffix }}</span>
  </div>
</template>

<script>
import FieldCell from '@/components/fields/FieldCell'

export default {
  name: 'CellNumber',
  extends: FieldCell,
  computed: {
    suffix () {
      return this.options.suffix
    },
  }
}
</script>

<style scoped>

</style>
